import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=1e09063c&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e09063c')) {
      api.createRecord('1e09063c', component.options)
    } else {
      api.reload('1e09063c', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=1e09063c&", function () {
      api.rerender('1e09063c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29xNSSoVRk0Zr/JS/pricelisthelp.vue"
export default component.exports